import React, { JSX } from "react"

import {
    Breadcrumbs,
    Button,
    Grid,
    Typography,
} from "@mui/material"

import Icon from "@mdi/react"
import { mdiPlusBox } from "@mdi/js"

import { Trans } from "@lingui/macro"
import { Link } from "react-router-dom"
import { RouteInfo } from "components/commons/page-header/routes-data"

interface PageHeaderProps
{
    title: string
    path?: string
	paths?: RouteInfo[]
	params?: any

    addButton?: string
    link?: string
    linkKey?: string
    addButtonModal?: string
    onClickButtonModal?: () => void
}
export class PageHeader extends React.Component<PageHeaderProps, {}>
{
	private definePage = (path: string): string|null => {
		if(path === "Dashboard home") {
			return "/"
		}

		return null
	}

	private generateBreadcrumbs = (): JSX.Element[] => {
		if(this.props.path) {
			return this.generateStringPathBreadcrumbs()
		}
		if(!this.props.paths) {
			return []
		}

		return this.props.paths!
			.map(it => this.createBreadcrumb(
				it.getPath(this.props.params?.[it.identification] ?? null),
				it.identification,
				it.title
			))
	}

	private createBreadcrumb = (to: string, key: string, label: string): JSX.Element => {
		return (<Link to={to}
				key={key}
				style={{
					textDecoration: "none",
					color: "inherit",
					fontSize: "0.7em",
					fontWeight: "600",
				}}
			>
				{label}
			</Link>
		)
	}

	private generateStringPathBreadcrumbs = (): JSX.Element[] => {
		let breadcrumbs: JSX.Element[] = []

		let path: string[] = this.props.path!.split(", ")
		for(let i = 0; i < path.length; i++) {
			const page = this.definePage(path[i])
			if(page === null) {
				breadcrumbs.push(this.createBreadcrumb(
					"",
					i.toString(),
					"## INVALID BREADCRUMB - PLEASE FIX ##"
				))
				continue
			}

			breadcrumbs.push(this.createBreadcrumb(
				page,
				i.toString(),
				path[i]
			))
		}

		return breadcrumbs
	}

	render()
	{
		const breadcrumbs = this.generateBreadcrumbs()

        return (
            <Grid container mt={1} mb={2}>
                <Grid item xs={10}>
                    <Typography variant="h6" color={"text"} sx={{ fontWeight: "600" }}>
                        <Trans id="page-header.title" comment="Title page header">
                            {this.props.title}
                        </Trans>
                    </Typography>
                    <Breadcrumbs
						separator=">"
                    >
                        {breadcrumbs}
                    </Breadcrumbs>
                </Grid>
                {this.props.addButton &&<Grid item xs={2} textAlign="right">
                    <Link key={this.props.linkKey} to={"/" + this.props.link}>
                        <Button
                            startIcon={<Icon path={mdiPlusBox} size={1} />}
                            variant="contained"
                            sx={{color: "background.default", mt: 1, backgroundColor: "secondary.main", textTransform: "none"}}
                            size="small"
                            disableElevation
                        >
                            <Typography>
                                <Trans id="page-header.add-button" comment="Add button">
                                    {this.props.addButton}
                                </Trans>
                            </Typography>
                        </Button>
                    </Link>
                </Grid>}
                {this.props.addButtonModal && this.props.onClickButtonModal && <Grid item xs={2} textAlign="right">
                    <Button
						startIcon={<Icon path={mdiPlusBox} size={1} />}
                        variant="contained"
                        sx={{color: "background.default", mt: 1, backgroundColor: "secondary.main", textTransform: "none"}}
                        size="small"
                        disableElevation
                        onClick={this.props.onClickButtonModal}
                    >
                        <Typography>
                            <Trans id="page-header.add-button" comment="Add button">
                                {this.props.addButtonModal}
                            </Trans>
                        </Typography>
                    </Button>
                </Grid>}
            </Grid>
        )
    }
}
